unit View.Banco_Carteiras.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewBanco_CarteirasList = class(TForm)
    btNew: TButton;
    Banco_CarteirasDataset: TXDataWebDataSet;
    Banco_CarteirasDatasetid: TIntegerField;
    Banco_CarteirasDatasetaliado_id: TIntegerField;
    Banco_CarteirasDatasetdata_base_id: TIntegerField;
    Banco_CarteirasDatasetconta_id: TIntegerField;
    Banco_CarteirasDatasettipo_id: TIntegerField;
    Banco_CarteirasDatasetstatus: TIntegerField;
    Banco_CarteirasDatasetnome: TStringField;
    Banco_CarteirasDatasetcodigo: TStringField;
    Banco_CarteirasDatasetcontrato: TStringField;
    Banco_CarteirasDatasetconvenio: TStringField;
    Banco_CarteirasDatasetvariacao: TStringField;
    Banco_CarteirasDatasetmensagem1: TStringField;
    Banco_CarteirasDatasetmensagem2: TStringField;
    Banco_CarteirasDatasetmensagem3: TStringField;
    Banco_CarteirasDatasettaxa_juros: TFloatField;
    Banco_CarteirasDatasettaxa_multa: TFloatField;
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto: TBooleanField;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada: TBooleanField;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao: TIntegerField;
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado: TFloatField;
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao: TIntegerField;
    Banco_CarteirasDatasetmensagem_desconto: TStringField;
    Banco_CarteirasDatasetcodigo_interno: TIntegerField;
    Banco_CarteirasDatasetexcluido: TBooleanField;
    Banco_CarteirasDatasetinclusao: TDateTimeField;
    Banco_CarteirasDatasetalteracao: TDateTimeField;
    Banco_CarteirasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewBanco_CarteirasList: TFViewBanco_CarteirasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBanco_CarteirasList }

procedure TFViewBanco_CarteirasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewBanco_CarteirasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBanco_CarteirasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewBanco_CarteirasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewBanco_CarteirasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewBanco_CarteirasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewBanco_CarteirasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Banco_CarteirasDataset.Connection.Model.DefaultSchema.FindEntityType(Banco_CarteirasDataset.EntitySetName),
      Banco_CarteirasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewBanco_CarteirasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('banco_carteiras', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Banco_CarteirasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewBanco_CarteirasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.banco_carteiras.list.pagination.info');
  btNew := TButton.Create('view.banco_carteiras.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.banco_carteiras.list.table');
  cbPageSize := TComboBox.Create('view.banco_carteiras.list.cbPageSize');
  edSearch := TEdit.Create('view.banco_carteiras.list.search');
  lcPaginator := TListControl.Create('view.banco_carteiras.list.pagination');
  Banco_CarteirasDataset := TXDataWebDataSet.Create(Self);
  Banco_CarteirasDatasetid := TIntegerField.Create(Self);
  Banco_CarteirasDatasetaliado_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetdata_base_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetconta_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasettipo_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetstatus := TIntegerField.Create(Self);
  Banco_CarteirasDatasetnome := TStringField.Create(Self);
  Banco_CarteirasDatasetcodigo := TStringField.Create(Self);
  Banco_CarteirasDatasetcontrato := TStringField.Create(Self);
  Banco_CarteirasDatasetconvenio := TStringField.Create(Self);
  Banco_CarteirasDatasetvariacao := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem1 := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem2 := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem3 := TStringField.Create(Self);
  Banco_CarteirasDatasettaxa_juros := TFloatField.Create(Self);
  Banco_CarteirasDatasettaxa_multa := TFloatField.Create(Self);
  Banco_CarteirasDatasetcarteira_cliente_emite_boleto := TBooleanField.Create(Self);
  Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada := TBooleanField.Create(Self);
  Banco_CarteirasDatasetdesconto_acrescimo_antecipacao := TIntegerField.Create(Self);
  Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado := TFloatField.Create(Self);
  Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao := TIntegerField.Create(Self);
  Banco_CarteirasDatasetmensagem_desconto := TStringField.Create(Self);
  Banco_CarteirasDatasetcodigo_interno := TIntegerField.Create(Self);
  Banco_CarteirasDatasetexcluido := TBooleanField.Create(Self);
  Banco_CarteirasDatasetinclusao := TDateTimeField.Create(Self);
  Banco_CarteirasDatasetalteracao := TDateTimeField.Create(Self);
  Banco_CarteirasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Banco_CarteirasDataset.BeforeLoadDFMValues;
  Banco_CarteirasDatasetid.BeforeLoadDFMValues;
  Banco_CarteirasDatasetaliado_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdata_base_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetconta_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasettipo_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetstatus.BeforeLoadDFMValues;
  Banco_CarteirasDatasetnome.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcodigo.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcontrato.BeforeLoadDFMValues;
  Banco_CarteirasDatasetconvenio.BeforeLoadDFMValues;
  Banco_CarteirasDatasetvariacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem1.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem2.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem3.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_juros.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_multa.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcarteira_cliente_emite_boleto.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem_desconto.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcodigo_interno.BeforeLoadDFMValues;
  Banco_CarteirasDatasetexcluido.BeforeLoadDFMValues;
  Banco_CarteirasDatasetinclusao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetalteracao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewBanco_CarteirasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_id';
      Title := 'conta_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo_id';
      Title := 'tipo_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo';
      Title := 'codigo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'contrato';
      Title := 'contrato';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'convenio';
      Title := 'convenio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'variacao';
      Title := 'variacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem1';
      Title := 'mensagem1';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem2';
      Title := 'mensagem2';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem3';
      Title := 'mensagem3';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_juros';
      Title := 'taxa_juros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_multa';
      Title := 'taxa_multa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'carteira_cliente_emite_boleto';
      Title := 'carteira_cliente_emite_boleto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'carteira_permite_liquidacao_antecipada';
      Title := 'carteira_permite_liquidacao_antecipada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desconto_acrescimo_antecipacao';
      Title := 'desconto_acrescimo_antecipacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_desconto_acrescimo_antecipado';
      Title := 'taxa_desconto_acrescimo_antecipado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'dias_limite_desconto_acrescimo_antecipacao';
      Title := 'dias_limite_desconto_acrescimo_antecipacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem_desconto';
      Title := 'mensagem_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Banco_CarteirasDataset.SetParentComponent(Self);
    Banco_CarteirasDataset.Name := 'Banco_CarteirasDataset';
    Banco_CarteirasDataset.EntitySetName := 'Banco_Carteiras';
    Banco_CarteirasDataset.Connection := DMConnection.ApiConnection;
    Banco_CarteirasDataset.Left := 72;
    Banco_CarteirasDataset.Top := 144;
    Banco_CarteirasDatasetid.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetid.Name := 'Banco_CarteirasDatasetid';
    Banco_CarteirasDatasetid.FieldName := 'id';
    Banco_CarteirasDatasetid.Required := True;
    Banco_CarteirasDatasetaliado_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetaliado_id.Name := 'Banco_CarteirasDatasetaliado_id';
    Banco_CarteirasDatasetaliado_id.FieldName := 'aliado_id';
    Banco_CarteirasDatasetaliado_id.Required := True;
    Banco_CarteirasDatasetdata_base_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdata_base_id.Name := 'Banco_CarteirasDatasetdata_base_id';
    Banco_CarteirasDatasetdata_base_id.FieldName := 'data_base_id';
    Banco_CarteirasDatasetdata_base_id.Required := True;
    Banco_CarteirasDatasetconta_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetconta_id.Name := 'Banco_CarteirasDatasetconta_id';
    Banco_CarteirasDatasetconta_id.FieldName := 'conta_id';
    Banco_CarteirasDatasettipo_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettipo_id.Name := 'Banco_CarteirasDatasettipo_id';
    Banco_CarteirasDatasettipo_id.FieldName := 'tipo_id';
    Banco_CarteirasDatasetstatus.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetstatus.Name := 'Banco_CarteirasDatasetstatus';
    Banco_CarteirasDatasetstatus.FieldName := 'status';
    Banco_CarteirasDatasetnome.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetnome.Name := 'Banco_CarteirasDatasetnome';
    Banco_CarteirasDatasetnome.FieldName := 'nome';
    Banco_CarteirasDatasetnome.Required := True;
    Banco_CarteirasDatasetnome.Size := 255;
    Banco_CarteirasDatasetcodigo.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcodigo.Name := 'Banco_CarteirasDatasetcodigo';
    Banco_CarteirasDatasetcodigo.FieldName := 'codigo';
    Banco_CarteirasDatasetcodigo.Size := 255;
    Banco_CarteirasDatasetcontrato.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcontrato.Name := 'Banco_CarteirasDatasetcontrato';
    Banco_CarteirasDatasetcontrato.FieldName := 'contrato';
    Banco_CarteirasDatasetcontrato.Size := 255;
    Banco_CarteirasDatasetconvenio.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetconvenio.Name := 'Banco_CarteirasDatasetconvenio';
    Banco_CarteirasDatasetconvenio.FieldName := 'convenio';
    Banco_CarteirasDatasetconvenio.Size := 255;
    Banco_CarteirasDatasetvariacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetvariacao.Name := 'Banco_CarteirasDatasetvariacao';
    Banco_CarteirasDatasetvariacao.FieldName := 'variacao';
    Banco_CarteirasDatasetvariacao.Size := 255;
    Banco_CarteirasDatasetmensagem1.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem1.Name := 'Banco_CarteirasDatasetmensagem1';
    Banco_CarteirasDatasetmensagem1.FieldName := 'mensagem1';
    Banco_CarteirasDatasetmensagem1.Size := 255;
    Banco_CarteirasDatasetmensagem2.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem2.Name := 'Banco_CarteirasDatasetmensagem2';
    Banco_CarteirasDatasetmensagem2.FieldName := 'mensagem2';
    Banco_CarteirasDatasetmensagem2.Size := 255;
    Banco_CarteirasDatasetmensagem3.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem3.Name := 'Banco_CarteirasDatasetmensagem3';
    Banco_CarteirasDatasetmensagem3.FieldName := 'mensagem3';
    Banco_CarteirasDatasetmensagem3.Size := 255;
    Banco_CarteirasDatasettaxa_juros.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_juros.Name := 'Banco_CarteirasDatasettaxa_juros';
    Banco_CarteirasDatasettaxa_juros.FieldName := 'taxa_juros';
    Banco_CarteirasDatasettaxa_multa.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_multa.Name := 'Banco_CarteirasDatasettaxa_multa';
    Banco_CarteirasDatasettaxa_multa.FieldName := 'taxa_multa';
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.Name := 'Banco_CarteirasDatasetcarteira_cliente_emite_boleto';
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.FieldName := 'carteira_cliente_emite_boleto';
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.Required := True;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.Name := 'Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada';
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.FieldName := 'carteira_permite_liquidacao_antecipada';
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.Required := True;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.Name := 'Banco_CarteirasDatasetdesconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.FieldName := 'desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.Name := 'Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado';
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.FieldName := 'taxa_desconto_acrescimo_antecipado';
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.Name := 'Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.FieldName := 'dias_limite_desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetmensagem_desconto.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem_desconto.Name := 'Banco_CarteirasDatasetmensagem_desconto';
    Banco_CarteirasDatasetmensagem_desconto.FieldName := 'mensagem_desconto';
    Banco_CarteirasDatasetmensagem_desconto.Size := 255;
    Banco_CarteirasDatasetcodigo_interno.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcodigo_interno.Name := 'Banco_CarteirasDatasetcodigo_interno';
    Banco_CarteirasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Banco_CarteirasDatasetcodigo_interno.Required := True;
    Banco_CarteirasDatasetexcluido.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetexcluido.Name := 'Banco_CarteirasDatasetexcluido';
    Banco_CarteirasDatasetexcluido.FieldName := 'excluido';
    Banco_CarteirasDatasetinclusao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetinclusao.Name := 'Banco_CarteirasDatasetinclusao';
    Banco_CarteirasDatasetinclusao.FieldName := 'inclusao';
    Banco_CarteirasDatasetalteracao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetalteracao.Name := 'Banco_CarteirasDatasetalteracao';
    Banco_CarteirasDatasetalteracao.FieldName := 'alteracao';
    Banco_CarteirasDatasetexclusao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetexclusao.Name := 'Banco_CarteirasDatasetexclusao';
    Banco_CarteirasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Banco_CarteirasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Banco_CarteirasDataset.AfterLoadDFMValues;
    Banco_CarteirasDatasetid.AfterLoadDFMValues;
    Banco_CarteirasDatasetaliado_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetdata_base_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetconta_id.AfterLoadDFMValues;
    Banco_CarteirasDatasettipo_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetstatus.AfterLoadDFMValues;
    Banco_CarteirasDatasetnome.AfterLoadDFMValues;
    Banco_CarteirasDatasetcodigo.AfterLoadDFMValues;
    Banco_CarteirasDatasetcontrato.AfterLoadDFMValues;
    Banco_CarteirasDatasetconvenio.AfterLoadDFMValues;
    Banco_CarteirasDatasetvariacao.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem1.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem2.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem3.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_juros.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_multa.AfterLoadDFMValues;
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.AfterLoadDFMValues;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.AfterLoadDFMValues;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.AfterLoadDFMValues;
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem_desconto.AfterLoadDFMValues;
    Banco_CarteirasDatasetcodigo_interno.AfterLoadDFMValues;
    Banco_CarteirasDatasetexcluido.AfterLoadDFMValues;
    Banco_CarteirasDatasetinclusao.AfterLoadDFMValues;
    Banco_CarteirasDatasetalteracao.AfterLoadDFMValues;
    Banco_CarteirasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
